import React from "react";
import { cn } from "utils/utils";

export const Table: React.FC<React.TableHTMLAttributes<HTMLTableElement>> = ({
  children,
  className,
  ...props
}) => (
  <table className={cn("table w-full", className)} {...props}>
    {children}
  </table>
);

export function TableContainer({
  children,
  className,
  ref,
  ...props
}: React.ComponentPropsWithRef<"div">) {
  return (
    <div
      ref={ref}
      className={cn("relative overflow-auto", className)}
      {...props}
    >
      {children}
    </div>
  );
}

export const TableHead: React.FC<
  React.HTMLAttributes<HTMLTableSectionElement>
> = ({ children, className, ...props }) => (
  <thead className={cn("sticky top-0", className)} {...props}>
    {children}
  </thead>
);

export const TableBody: React.FC<
  React.HTMLAttributes<HTMLTableSectionElement>
> = ({ children, ...props }) => <tbody {...props}>{children}</tbody>;

export const TableHeader: React.FC<
  React.ThHTMLAttributes<HTMLTableCellElement>
> = ({ children, className, ...props }) => (
  <th
    className={cn(
      "after:border-base-300 px-1 py-2 text-sm after:inset-0 after:border-b",
      className
    )}
    {...props}
  >
    {children}
  </th>
);

export const TableCell: React.FC<
  React.TdHTMLAttributes<HTMLTableCellElement>
> = ({ children, className, ...props }) => (
  <td className={cn("px-1 py-1", className)} {...props}>
    {children}
  </td>
);

export function TableRow({
  children,
  className,
  ref,
  ...props
}: React.ComponentPropsWithRef<"tr">) {
  return (
    <tr ref={ref} className={className ? cn(className) : undefined} {...props}>
      {children}
    </tr>
  );
}

export const ResponsiveTableCell: React.FC<
  React.TdHTMLAttributes<HTMLTableCellElement> & { breakpoint?: string }
> = ({ children, className, breakpoint = "md", ...props }) => (
  <TableCell
    className={cn(`hidden ${breakpoint}:table-cell`, className)}
    {...props}
  >
    {children}
  </TableCell>
);
